"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withStaticAppInfo = void 0;

var _core = require("./core");

var formatVersion = function formatVersion(version) {
  if (version == null) {
    return 'unknown';
  }

  if (version === 'static') {
    return 'dev';
  }

  return version.replace('static-', '');
};

var withStaticAppInfo = function withStaticAppInfo(options) {
  return options.appInfo ? (0, _core.header)('X-HubSpot-Static-App-Info', options.appInfo.name + "@" + formatVersion(options.appInfo.version))(options) : options;
};

exports.withStaticAppInfo = withStaticAppInfo;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.230/js/middlewares/staticAppInfo.js
// module id = 222
// module chunks = 0